import { handleResponse } from "../../Utils/API/handle-reponse";
import * as apiHelper from "../../Utils/API/apiHelper";

export const dataService = {
  // General
  login,
  requestLogin,
  getSystemParameters,

  // Company
  getAllCompaniesByUserId,
  getAllActiveCompaniesByUserId,
  getUserAndCompanyData,
  saveCompany,
  createCompany,
  modifyCompany,
  getCompaniesAndUsersBySubscriberUniqueId,
  setCompanyState,
  transferCompany,
  hideCompanyFromUserIdByCompanyId,

  // CostBundleType
  getAllCostBundleTypes,

  // Currency
  getAllCurrencies,
  getCurrencyById,

  // External Api
  createNewApi,
  getExternalApiByUniqueId,
  getApis,
  modifyApi,
  deleteApi,

  // External Api Type
  getAllExternalApiTypes,

  // External Api Enum Options
  getEnumOptionsByExternalApiId,
  createEnumOption,
  modifyEnumOption,
  deleteEnumOption,

  // DataList
  createNewDataList,
  getLists,
  getDataListByUniqueId,
  deleteDataList,
  modifyDataList,
  getListItems,
  getListItemsByListIdAndProjectGuid,

  // PriceBundle
  getAllPriceBundles,
  getAllProjectAvailablePriceBundles,
  createPriceBundle,
  updatePriceBundle,
  deletePriceBundle,

  // PriceDefinition
  getAllPriceDefinitionsWithEntries,
  getAllPriceDefinitionsWithCurrentPrice,
  createPriceDefinition,
  updatePriceDefinition,
  schedulePriceChange,
  deletePriceChange,
  deletePriceDefinition,
  getPriceHistory,
  correctPriceEntry,

  // Project
  createNewProject,
  deleteProject,
  getProjectDetails,
  getProjectDetailsByQr,
  getProjectByQr,
  getAllProjectInfoByProjectId,
  getProjectLocationsByUserId,
  getProjectNamesByUserId,
  getProjectDetailWithComments,
  getProjectAndDetails,
  getProjectByProjectQr,
  getProjectByProjectIdUserId,
  getAllUserCompanyProjects,
  getUserCompanyProjectOverview, // Project data nescessary for project overview
  findProjects,
  updateProjects,
  updateProjectSingleStopwatch,
  projectHasMeasurements,

  // ProjectDetail
  projectDetailHasMeasurements,
  updateProjectDetailCostBundle,
  bulkUpdateProjectDetailCostBundle,

  // Measurements
  getByProjectId, // Get measurements by project id
  saveMeasurement,
  saveMeasurementWithComment,
  getMeasurementById,
  get24HoursBeforeLastMeasurementById,
  getAllProjectMeasurementsById,
  getAllProjectGraphMeasurementsById,
  getAllProjectGraphMeasurementsByIdAndDateRange,
  updateMeasurement,
  getMeasurementPriceDefinitions,

  getProjectMeasurementsByDateAndId,
  getMeasurementForModify,
  getMeasurementsByUserIdDateLocationName,
  getMeasurementsByUserIdDate,
  getMeasurementsByQrCode,
  getMeasurement,
  getMeasurementByIdAndDate,
  saveAndResetMeasurements,

  setMeasurementInactive,
  setMeasurementsInactiveByIdList,
  setMeasurementFinished,

  // Graph
  getAllGraphConfigurationsByCompanyId,
  getAllGraphConfigurationsByCompanyIdList,
  getAllUserCompanyGraphConfigurations,
  getGraphConfigurationByUniqueId,
  getGraphConfigurationByUniqueIdAndDateRange,
  getGraphConfigurationForViewingByUniqueId,
  getGraphConfigurationForViewingByUniqueIdAndDateRange,
  createNewGraphConfiguration,
  updateGraphConfiguration,
  publishGraphConfiguration,
  deleteGraphConfiguration,

  // User
  getUserByEmail,
  getUserByEmailAddress,
  updateUserData,
  createUser,
  addUser, //Add existing user to company
  updateUser,
  changeUserActive,

  //Roles
  getAllRoles,

  getResources,
  getResourcesByDateRange,
  getTypes,
  saveText,
  saveTime,
  saveCount,
  getName,
  newMediaImage,
  newMediaImageWithComment,
  GetImageById,
  getValueTypes,

  // FinancialTypes
  getAllUserCompanyFinancialTypes,
  createFinancialType,
  updateFinancialType,

  // Recurring Financials
  getRecurringFinancialsByCompanyIdsAndDateRange,

  // Account category
  getAllUserCompanyAccountCategories,
  createAccountCategory,
  updateAccountCategory,
  deleteAccountCategory,

  // Account
  getAllUserCompanyAccounts,
  createAccount,
  updateAccount,
  createAccounts,
  deleteAccount,
  // updateAccounts,
  getAllAccountsForGraphConfigurationByUniqueId,
  getAllPriceBundlesForGraphConfigurationByUniqueId,
  getAllPriceBundlesForGraphConfigurationByUniqueIdPublic,

  // General Ledger Account
  getReportByCompanyIdAndDateRange,
  getMeasurementsByCompanyIdAndDateRange,
  getAllMeasurementsByUserId,

  // Subscribers
  getAllSubscribers,
  createSubscriber,
  updateSubscriber,
  getSubscriberUsageByUniqueIdForDateRange,
  suspendSubscriptionBySubscriberUniqueId,

  // Subscriptions
  getSubscriptionTierByUserId,
  getSubscriptionByAdminUserId,
  getSubscriptionBySubscriberUniqueId,
  getSubscriptionByProjectQr,
  checkSubscriptionUserLimitByCompanyId,
  checkSubscriptionCompanyLimitByCompanyId,

  // SubscriptionTiers
  getAllSubscriptionTiers,
};

// Currency
export function getAllCurrencies() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETALLCURRENCIES);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getCurrencyById(currencyId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETCURRENCYBYID);
  url += "?currencyId=" + currencyId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function login(email, password) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      email: email,
      password: password,
    }),
  };

  let url = apiHelper.ComposeUri(apiHelper.LOGIN_URL);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function requestLogin(firstName, lastName, company, email) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: email,
      lastName: lastName,
      firstName: firstName,
      company: company,
    }),
  };

  let url = apiHelper.ComposeUri(apiHelper.REQUESTLOGIN_URL);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function createNewProject(GetUserId, ProjectName, ResourceName, resourceId, CompanyId, CompanyName, FromDate, ToDate, projectrows, SingleStopwatch) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      UserId: GetUserId,
      ProjectName: ProjectName,
      ResourceName: ResourceName,
      resourceId: resourceId,
      CompanyId: CompanyId,
      CompanyName: CompanyName,
      FromDate: FromDate,
      ToDate: ToDate,
      SingleStopwatch: SingleStopwatch,
      Details: projectrows,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATENEWPROJECT);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function getUserByEmail(email) {
  const requestOptions = { method: "GET" };

  let url = apiHelper.ComposeUri(apiHelper.GETUSERBYEMAIL_URL);
  url += "?email=" + email;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getUserByEmailAddress(email, accessToken) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(accessToken),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETUSERBYEMAILADDRESS);
  url += "?email=" + email;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllCompaniesByUserId(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETCOMPANIES_URL);
  url += "?userId=" + userId;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllActiveCompaniesByUserId(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLACTIVECOMPANIESBYUSERID);
  url += "?userId=" + userId;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getUserAndCompanyData(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETUSERANDCOMPANYDATA_URL);
  url += "?userId=" + userId;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getCompaniesAndUsersBySubscriberUniqueId(subscriberUniqueId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETCOMPANIESANDUSERSBYSUBSCRIBERUNIQUEID);
  url += "?subscriberUniqueId=" + subscriberUniqueId;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function setCompanyState(companyId, isActive) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.SETCOMPANYSTATE);
  url += "?companyId=" + companyId + "&isActive=" + isActive;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function transferCompany(transferCompanyObject) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      receivingSubscriberUniqueId: transferCompanyObject.receivingSubscriberUniqueId,
      companyId: transferCompanyObject.companyId,
      transferUsers: transferCompanyObject.transferUsers,
    }),
  };

  let url = apiHelper.ComposeUri(apiHelper.TRANSFERCOMPANY);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function hideCompanyFromUserIdByCompanyId(companyId, userId, hide) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.HIDECOMPANYFROMUSERIDBYCOMPANYID);
  url += "?companyId=" + companyId + "&userId=" + userId + "&hide=" + hide;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

// CostBundleType

export function getAllCostBundleTypes() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETALLCOSTBUNDLETYPES);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      return error;
    });
}

export function getResources(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETRESOURCES_URL);
  url += "?userId=" + userId;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getTypes() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETTYPES_URL);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function saveCompany(companyName, GetUserId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Name: companyName,
      UserId: GetUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.SAVECOMPANY);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function createCompany(companyObject) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      companyName: companyObject.name,
      currencyId: companyObject.currencyId,
      insertedByUserId: companyObject.insertedByUserId,
      subscriberUniqueId: companyObject.subscriberUniqueId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATECOMPANY);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function modifyCompany(companyObject) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      id: companyObject.id,
      companyName: companyObject.name,
      currencyId: companyObject.currencyId,
      updatedByUserId: companyObject.updatedByUserId,
      subscriberUniqueId: companyObject.subscriberUniqueId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.MODIFYCOMPANY);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function findProjects(CompanyId, GetUserId, FromDate, ToDate, ResourceName) {
  const requestOptions = { method: "GET" };

  let url = apiHelper.ComposeUri(apiHelper.GETPROJECTS_URL);
  url += "?UserId=" + GetUserId + "&CompanyId=" + CompanyId + "&FromDate=" + FromDate + "&ToDate=" + ToDate + "&ResourceName=" + ResourceName;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function updateProjects(GetUserId, ProjectName, ResourceName, resourceId, OldCompanyId, CompanyId, CompanyName, FromDate, ToDate, projectrows, ProjectId, ProjectQr, SingleStopwatch) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      ProjectId: ProjectId,
      UserId: GetUserId,
      ProjectName: ProjectName,
      ResourceName: ResourceName,
      resourceId: resourceId,
      OldCompanyId: OldCompanyId,
      CompanyId: CompanyId,
      CompanyName: CompanyName,
      FromDate: FromDate,
      ToDate: ToDate,
      QrCode: ProjectQr,
      SingleStopwatch: SingleStopwatch,
      Details: projectrows,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEPROJECTS_URL);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function updateProjectSingleStopwatch(projectQr, isSingleStopwatch) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      ProjectQr: projectQr,
      IsSingleStopwatch: isSingleStopwatch,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEPROJECTSINGLESTOPWATCH_URL);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function projectHasMeasurements(projectQr) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.PROJECTHASMEASUREMENTS);
  url += "?ProjectQr=" + projectQr;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function projectDetailHasMeasurements(projectDetailId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.PROJECTDETAILHASMEASUREMENTS);
  url += "?ProjectDetailId=" + projectDetailId;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function updateProjectDetailCostBundle(updateData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(updateData),
  };

  let url = apiHelper.ComposeUri(apiHelper.UPDATEPROJECTDETAILCOSTBUNDLE);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function bulkUpdateProjectDetailCostBundle(bulkUpdateData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(bulkUpdateData),
  };

  let url = apiHelper.ComposeUri(apiHelper.BULKUPDATEPROJECTDETAILCOSTBUNDLE);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function updateUserData(email, firstName, lastName) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Email: email,
      FirstName: firstName,
      LastName: lastName,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEUSERDATA_URL);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function createUser(userObject) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      emailAddress: userObject.email,
      firstName: userObject.firstName,
      name: userObject.name,
      fireBaseId: userObject.fireBaseId,
      roles: userObject.roles,
      companyId: userObject.companyId,
      insertedByUserId: userObject.insertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATEUSER_URL);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      console.error("createUser API error:", error);
      return null;
    });
}

export function addUser(userObject) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      emailAddress: userObject.email,
      roles: userObject.roles,
      companyId: userObject.companyId,
      insertedByUserId: userObject.insertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.ADDUSER_URL);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function updateUser(userObject) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      emailAddress: userObject.email,
      firstName: userObject.firstName,
      name: userObject.name,
      fireBaseId: userObject.fireBaseId,
      roles: userObject.roles,
      companyId: userObject.companyId,
      insertedByUserId: userObject.insertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEUSER_URL);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function changeUserActive(userObject) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      enabled: userObject.enabled,
      updateByUserId: userObject.updateByUserId,
      userId: userObject.userId,
      companyId: userObject.companyId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CHANGEUSERACTIVE);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllRoles() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETALLROLES_URL);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// Measurements

export function getMeasurement(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENT_URL);
  url += "?userId=" + userId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function setMeasurementInactive(measurementId) {
  // update measurement to isActive = false
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: measurementId,
    }),
  };

  let url = apiHelper.ComposeUri(apiHelper.SETMEASUREMENTINACTIVE);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function setMeasurementsInactiveByIdList(measurementIdList) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(measurementIdList),
  };

  let url = apiHelper.ComposeUri(apiHelper.SETMEASUREMENTSINACTIVEBYIDLIST);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function setMeasurementFinished(measurementId) {
  // update measurement to isRunning = false
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      measurementId: measurementId,
    }),
  };

  let url = apiHelper.ComposeUri(apiHelper.SETMEASUREMENTFINISHED);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getMeasurementForModify(userId, FromDate, ToDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENTFORMODIFY_URL);
  url += "?userId=" + userId + "&FromDate=" + FromDate + "&ToDate=" + ToDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function updateMeasurement(measurement) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      id: measurement.id,
      startTime: measurement.startTime,
      stopTime: measurement.stopTime,
      measurementValue: measurement.measurementValue,
      commentText: measurement.commentText,
      updatedByUserId: measurement.updatedByUserId,
    }),
  };

  let url = apiHelper.ComposeUri(apiHelper.UPDATEMEASUREMENT);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function getMeasurementPriceDefinitions(measurementId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENTPRICEDEFINITIONS);
  url += "?measurementId=" + measurementId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => null);
}

// PriceBundle
export function getAllPriceBundles(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETALLPRICEBUNDLES);
  url += "?userId=" + userId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function getAllProjectAvailablePriceBundles(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETALLPROJECTAVAILABLEPRICEBUNDLES);
  url += "?userId=" + userId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function createPriceBundle(priceBundle) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      reference: priceBundle.reference,
      name: priceBundle.name,
      description: priceBundle.description,
      accountId: priceBundle.accountId,
      companyId: priceBundle.companyId,
      costBundleTypeId: priceBundle.costBundleTypeId,
      priceBundleItems: priceBundle.priceBundleItems,
      insertedByUserId: priceBundle.insertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATEPRICEBUNDLE);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function updatePriceBundle(priceBundle) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      uniqueId: priceBundle.uniqueId,
      reference: priceBundle.reference,
      name: priceBundle.name,
      description: priceBundle.description,
      accountId: priceBundle.accountId,
      costBundleTypeId: priceBundle.costBundleTypeId,
      priceBundleItems: priceBundle.priceBundleItems,
      updatedByUserId: priceBundle.updatedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEPRICEBUNDLE);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function deletePriceBundle(priceBundleId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(priceBundleId),
  };
  let url = apiHelper.ComposeUri(apiHelper.DELETEPRICEBUNDLE);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

// PriceDefinition
export function getAllPriceDefinitionsWithEntries(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETALLPRICEDEFINITIONSWITHENTRIES);
  url += "?userId=" + userId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function getAllPriceDefinitionsWithCurrentPrice(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETALLPRICEDEFINITIONSWITHCURRENTPRICE);
  url += "?userId=" + userId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function createPriceDefinition(priceDefinition) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      code: priceDefinition.code,
      name: priceDefinition.name,
      description: priceDefinition.description,
      companyId: priceDefinition.companyId,
      price: priceDefinition.price,
      unitOfMeasurement: priceDefinition.unitOfMeasurement,
      currencyId: priceDefinition.currencyId,
      defaultAccountId: priceDefinition.defaultAccountId,
      insertedByUserId: priceDefinition.insertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATEPRICEDEFINITION);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function updatePriceDefinition(priceDefinition) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      id: priceDefinition.id,
      code: priceDefinition.code,
      name: priceDefinition.name,
      description: priceDefinition.description,
      price: priceDefinition.price,
      unitOfMeasurement: priceDefinition.unitOfMeasurement,
      currencyId: priceDefinition.currencyId,
      defaultAccountId: priceDefinition.defaultAccountId,
      updatedByUserId: priceDefinition.updatedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEPRICEDEFINITION);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function schedulePriceChange(priceChange) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      priceDefinitionId: priceChange.priceDefinitionId,
      price: priceChange.price,
      validFrom: priceChange.validFrom,
      insertedByUserId: priceChange.insertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.SCHEDULEPRICECHANGE);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function deletePriceChange(priceEntryId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(priceEntryId), // send as int, not object
  };
  let url = apiHelper.ComposeUri(apiHelper.DELETEPRICECHANGE);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function deletePriceDefinition(priceDefinitionId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(priceDefinitionId),
  };
  let url = apiHelper.ComposeUri(apiHelper.DELETEPRICEDEFINITION);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function getPriceHistory(priceDefinitionId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETPRICEHISTORY);
  url += "?priceDefinitionId=" + priceDefinitionId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function correctPriceEntry(correction) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      priceEntryId: correction.priceEntryId,
      priceDefinitionId: correction.priceDefinitionId,
      originalPrice: correction.originalPrice,
      correctedPrice: correction.correctedPrice,
      reason: correction.reason,
      correctedByUserId: correction.correctedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CORRECTPRICEENTRY);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

// Project
export function getAllProjectInfoByProjectId(projectId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLPROJECTINFOBYPROJECTID);
  url += "?projectId=" + projectId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}
export function getProjectDetails(Qr) {
  const requestOptions = { method: "GET" };

  let url = apiHelper.ComposeUri(apiHelper.GETPROJECTDETAILS_URL);
  url += "?qr=" + Qr;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getProjectDetailsByQr(Qr) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETPROJECTDETAILSBYQR_URL);
  url += "?qr=" + Qr;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function saveText(projectDetailId, StartTime, TextValue) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ProjectDetailId: projectDetailId,
      StartTime: StartTime,
      TextValue: TextValue,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.SAVETEXT);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function saveTime(projectDetailId, StartTime, stopwatch) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ProjectDetailId: projectDetailId,
      StartTime: StartTime,
      DateValue: stopwatch,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.SAVETIME);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function saveCount(projectDetailId, StartTime, counterValue) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ProjectDetailId: projectDetailId,
      StartTime: StartTime,
      CounterValue: counterValue,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.SAVECOUNT);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function saveMeasurement(measurement) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ProjectDetailId: measurement.id,
      StartTime: measurement.startTime,
      Value: measurement.value,
      StartValue: measurement.startValue,
      StopValue: measurement.stopValue,
      Price: measurement.price,
      IsNegative: measurement.isNegative,
      CurrencyId: measurement.currencyId,
      Running: measurement.running,
      ControlTypeId: measurement.controlTypeId,
    }),
  };

  let url = apiHelper.ComposeUri(apiHelper.SAVEMEASUREMENT);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function saveMeasurementWithComment(measurement) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ProjectDetailId: measurement.id,
      StartTime: measurement.startTime,
      Value: measurement.value,
      StartValue: measurement.startValue,
      StopValue: measurement.stopValue,
      Price: measurement.price,
      CurrencyId: measurement.currencyId,
      Running: measurement.running,
      controlTypeId: measurement.controlTypeId,
      Image: measurement.commentImage,
      Comment: measurement.commentText,
    }),
  };

  let url = apiHelper.ComposeUri(apiHelper.SAVEMEASUREMENTWITHCOMMENT);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function saveAndResetMeasurements(measurements) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      measurements: measurements,
    }),
  };

  let url = apiHelper.ComposeUri(apiHelper.SAVEANDRESETMEASUREMENTS);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getName(Qr) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETNAME_URL);
  url += "?Qr=" + Qr;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getMeasurementById(userId, ProjectId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENTBYID_URL);
  url += "?userId=" + userId + "&ProjectId=" + ProjectId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function get24HoursBeforeLastMeasurementById(projectId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GET24HOURSBEFORELASTMEASUREMENTBYID);
  url += "?ProjectId=" + projectId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllProjectMeasurementsById(projectId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLPROJECTMEASUREMENTSBYID);
  url += "?ProjectId=" + projectId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllProjectGraphMeasurementsById(projectId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLPROJECTGRAPHMEASUREMENTSBYID);
  url += "?ProjectId=" + projectId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllProjectGraphMeasurementsByIdAndDateRange(projectId, fromDate, toDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETALLPROJECTGRAPHMEASUREMENTSBYIDANDDATERANGE);
  url += "?ProjectId=" + projectId + "&FromDate=" + fromDate + "&ToDate=" + toDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      return error;
    });
}

export function getProjectMeasurementsByDateAndId(projectId, fromDate, toDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETPROJECTMEASUREMENTSBYDATEANDID);
  url += "?ProjectId=" + projectId + "&FromDate=" + fromDate + "&ToDate=" + toDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getMeasurementByIdAndDate(userId, ProjectId, FromDate, ToDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENTBYIDANDDATE_URL);
  url += "?userId=" + userId + "&ProjectId=" + ProjectId + "&FromDate=" + FromDate + "&ToDate=" + ToDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getByProjectId(ProjectId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENTSBYPROJECTID_URL);
  url += "?ProjectId=" + ProjectId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function deleteProject(projectId, UserId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      ProjectId: projectId,
      UserId: UserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.DELETEPROJECT);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function createNewDataList(Name, CompanyId, Description, IsMultiSelect, InsertedOn, InsertedByUserId, DataListItems) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Name: Name,
      CompanyId: CompanyId,
      Description: Description,
      IsMultiSelect: IsMultiSelect,
      InsertedOn: InsertedOn,
      InsertedByUserId: InsertedByUserId,
      DataListItems: DataListItems,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATENEWDATALIST);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getLists(UserId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETLISTS);
  url += "?UserId=" + UserId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getDataListByUniqueId(uniqueId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETDATALISTBYUNIQUEID);
  url += "?uniqueId=" + uniqueId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function deleteDataList(Name, Description, CompanyId, IsMultiSelect, InsertedOn, InsertedByUserId, DataListItems, listId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Name: Name,
      CompanyId: CompanyId,
      Description: Description,
      IsMultiSelect: IsMultiSelect,
      InsertedOn: InsertedOn,
      InsertedByUserId: InsertedByUserId,
      DataListItems: DataListItems,
      Id: listId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.DELETEDATALIST);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function modifyDataList(Name, Description, CompanyId, IsMultiSelect, InsertedOn, InsertedByUserId, DataListItems, listId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Name: Name,
      Description: Description,
      CompanyId: CompanyId,
      IsMultiSelect: IsMultiSelect,
      InsertedOn: InsertedOn,
      InsertedByUserId: InsertedByUserId,
      DataListItems: DataListItems,
      Id: listId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.MODIFYDATALIST);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getListItems(dataListId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETLISTITEMS);
  url += "?dataListId=" + dataListId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getListItemsByListIdAndProjectGuid(dataListId, projectGuid) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETLISTITEMSBYLISTIDANDPROJECTGUID);
  url += "?dataListId=" + dataListId + "&projectGuid=" + projectGuid;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function newMediaImage(InsertedOn, Image, ProjectDetailId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      ProjectDetailId: ProjectDetailId,
      InsertedOn: InsertedOn,
      Image: Image,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.NEWMEDIAIMAGE);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function newMediaImageWithComment(InsertedOn, Image, ProjectDetailId, CommentText) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      ProjectDetailId: ProjectDetailId,
      InsertedOn: InsertedOn,
      Image: Image,
      Comment: CommentText,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.NEWMEDIAIMAGEWITHCOMMENT);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function GetImageById(ImageId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETIMAGEBYID);
  url += "?ImageId=" + ImageId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getSystemParameters() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETSYSTEMPARAMETERS);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getProjectLocationsByUserId(userId, FromDate, ToDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETLOCATION_URL);
  url += "?UserId=" + userId + "&FromDate=" + FromDate + "&ToDate=" + ToDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getResourcesByDateRange(userId, FromDate, ToDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETRESOURCESBYDATERANGE_URL);
  url += "?UserId=" + userId + "&FromDate=" + FromDate + "&ToDate=" + ToDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getProjectNamesByUserId(userId, FromDate, ToDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETPROJECTNAMES_URL);
  url += "?UserId=" + userId + "&FromDate=" + FromDate + "&ToDate=" + ToDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getMeasurementsByUserIdDateLocationName(userId, FromDate, ToDate, Location, ProjectName) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENTBYDATELOCATIONNAME);
  url += "?UserId=" + userId + "&FromDate=" + FromDate + "&ToDate=" + ToDate + "&Location=" + Location + "&ProjectName=" + ProjectName;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllMeasurementsByUserId(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLMEASUREMENTSBYUSERID);
  url += "?UserId=" + userId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getMeasurementsByUserIdDate(userId, FromDate, ToDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENTBYDATEANDUSER);
  url += "?UserId=" + userId + "&FromDate=" + FromDate + "&ToDate=" + ToDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getMeasurementsByQrCode(qrCode) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENTBYQR);
  url += "?qr=" + qrCode;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getProjectDetailWithComments(Qr) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETDETAILMEASUREMENTSANDCOMMENTS);
  url += "?Qr=" + Qr;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getProjectAndDetails(UserId, Page, PageSize) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETPROJECTSANDDETAILS);
  url += "?UserId=" + UserId + "&Page=" + Page + "&PageSize=" + PageSize;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getProjectByQr(qr) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETPROJECTBYQR);
  url += "?qr=" + qr;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getProjectByProjectQr(projectQr) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETPROJECTBYPROJECTQR);
  url += "?ProjectQr=" + projectQr;
  return fetch(url, requestOptions).then(handleResponse);
}

export function getProjectByProjectIdUserId(ProjectId, UserId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETPROJECTBYPROJECTIDUSERID);
  url += "?ProjectId=" + ProjectId + "&UserId=" + UserId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllUserCompanyProjects(UserId, Page, PageSize) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLUSERCOMPANYPROJECTS);
  url += "?UserId=" + UserId + "&Page=" + Page + "&PageSize=" + PageSize;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getUserCompanyProjectOverview(UserId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETUSERCOMPANYPROJECTOVERVIEW);
  url += "?UserId=" + UserId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getValueTypes() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETVALUETYPES);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllGraphConfigurationsByCompanyId(companyId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLLGRAPHCONFIGURATIONSBYCOMPANYID);
  url += "?CompanyId=" + companyId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllGraphConfigurationsByCompanyIdList(companyIds) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let idString = "";
  for (var id of companyIds) {
    idString += String(id) + ",";
  }
  idString = idString.substring(0, idString.length - 1);
  let url = apiHelper.ComposeUri(apiHelper.GETALLLGRAPHCONFIGURATIONSBYCOMPANYIDLIST);
  url += `?companyIds=${idString}`;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllUserCompanyGraphConfigurations(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETALLUSERCOMPANYGRAPHCONFIGURATIONS);
  url += `?userId=${userId}`;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getGraphConfigurationByUniqueId(uniqueId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETGRAPHCONFIGURATIONBYUNIQUEID);
  url += "?UniqueId=" + uniqueId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getGraphConfigurationByUniqueIdAndDateRange(uniqueId, fromDate, toDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETGRAPHCONFIGURATIONBYUNIQUEIDANDDATERANGE);
  url += `?UniqueId=${uniqueId}&FromDate=${fromDate}&ToDate=${toDate}`;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      return error;
    });
}

export function getGraphConfigurationForViewingByUniqueId(uniqueId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETGRAPHCONFIGURATIONFORVIEWINGBYUNIQUEID);
  url += "?UniqueId=" + uniqueId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getGraphConfigurationForViewingByUniqueIdAndDateRange(uniqueId, fromDate, toDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.GETGRAPHCONFIGURATIONFORVIEWINGBYUNIQUEIDANDDATERANGE);
  url += `?UniqueId=${uniqueId}&FromDate=${fromDate}&ToDate=${toDate}`;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      return error;
    });
}

export function createNewGraphConfiguration(CompanyId, Name, Description, MetaData, IsPublic, InsertedByUserId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      CompanyId: CompanyId,
      Name: Name,
      Description: Description,
      MetaData: MetaData,
      IsPublic: IsPublic,
      InsertedByUserId: InsertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATENEWGRAPHCONFIGURATION);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function updateGraphConfiguration(Id, CompanyId, Name, Description, MetaData, IsPublic, InsertedByUserId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Id: Id,
      CompanyId: CompanyId,
      Name: Name,
      Description: Description,
      MetaData: MetaData,
      IsPublic: IsPublic,
      InsertedByUserId: InsertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEGRAPHCONFIGURATION);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function publishGraphConfiguration(id, publish) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.PUBLISHGRAPHCONFIGURATION);
  url += "?Id=" + id + "&Publish=" + publish;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function deleteGraphConfiguration(id, userId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.DELETEGRAPHCONFIGURATION);
  url += "?id=" + id + "&userId=" + userId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// Financial types
export function getAllUserCompanyFinancialTypes(userId, page, pageSize) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLUSERCOMPANYFINANCIALTYPES);
  url += "?UserId=" + userId + "&Page=" + page + "&PageSize=" + pageSize;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function createFinancialType(financialType) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      name: financialType.name,
      companyId: financialType.companyId,
      isRevenue: financialType.isRevenue,
      insertedByUserId: financialType.insertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATEFINANCIALTYPE);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function updateFinancialType(financialType) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      id: financialType.id,
      name: financialType.name,
      companyId: financialType.companyId,
      isRevenue: financialType.isRevenue,
      updatedByUserId: financialType.updatedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEFINANCIALTYPE);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// Recurring Financials
export function getRecurringFinancialsByCompanyIdsAndDateRange(companyIds, fromDate, toDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETRECURRINGFINANCIALSBYCOMPANYIDSANDDATERANGE);
  const idParams = companyIds.map(id => `companyIds=${id}`).join("&");
  url += `?${idParams}&fromDate=${fromDate}&toDate=${toDate}`;
  
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// AccountCategory
export function getAllUserCompanyAccountCategories(userId, page, pageSize) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLUSERCOMPANYACCOUNTCATEGORIES);
  url += "?UserId=" + userId + "&Page=" + page + "&PageSize=" + pageSize;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function createAccountCategory(accountCategory) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      name: accountCategory.name,
      companyId: accountCategory.companyId,
      isRevenue: accountCategory.isRevenue,
      insertedByUserId: accountCategory.insertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATEACCOUNTCATEGORY);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function updateAccountCategory(accountCategory) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      id: accountCategory.id,
      name: accountCategory.name,
      companyId: accountCategory.companyId,
      isRevenue: accountCategory.isRevenue,
      updatedByUserId: accountCategory.updatedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEACCOUNTCATEGORY);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function deleteAccountCategory(accountCategoryId, userId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.DELETEACCOUNTCATEGORY);
  url += "?accountCategoryId=" + accountCategoryId + "&userId=" + userId;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// Account
export function getAllUserCompanyAccounts(userId, page, pageSize) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLUSERCOMPANYACCOUNTS);
  url += "?UserId=" + userId + "&Page=" + page + "&PageSize=" + pageSize;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function createAccount(account) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      name: account.name,
      accountCategoryId: account.accountCategoryId,
      insertedByUserId: account.insertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATEACCOUNT);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function updateAccount(updateAccount) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(updateAccount),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATEACCOUNT);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function createAccounts(newAccounts) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(newAccounts),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATEACCOUNTS);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function deleteAccount(accountId, userId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };
  let url = apiHelper.ComposeUri(apiHelper.DELETEACCOUNT);
  url += "?accountId=" + accountId + "&userId=" + userId;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllAccountsForGraphConfigurationByUniqueId(uniqueId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLACCOUNTSFORGRAPHCONFIGURTATIONBYUNIQUEID);
  url += "?GraphConfigurationUniqueId=" + uniqueId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllPriceBundlesForGraphConfigurationByUniqueId(uniqueId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLPRICEBUNDLESFORGRAPHCONFIGURATIONBYUNIQUEID);
  url += "?GraphConfigurationUniqueId=" + uniqueId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getAllPriceBundlesForGraphConfigurationByUniqueIdPublic(uniqueId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLPRICEBUNDLESFORGRAPHCONFIGURATIONBYUNIQUEIDPUBLIC);
  url += "?GraphConfigurationUniqueId=" + uniqueId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// General Ledger Account
export function getReportByCompanyIdAndDateRange(companyId, fromDate, toDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETREPORTBYCOMPANYIDANDDATERANGE);
  url += "?CompanyId=" + companyId + "&FromDate=" + fromDate + "&ToDate=" + toDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getMeasurementsByCompanyIdAndDateRange(companyId, fromDate, toDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETMEASUREMENTSBYCOMPANYIDANDDATERANGE);
  url += "?CompanyId=" + companyId + "&FromDate=" + fromDate + "&ToDate=" + toDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// External Api
export function createNewApi(Name, Description, apiTypeId, CompanyId, ApiFormat, InsertedByUserId, ExternalApiEnumBehaviorTypeId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Name: Name,
      Description: Description,
      ExternalApiTypeId: apiTypeId,
      ExternalApiEnumBehaviorTypeId: ExternalApiEnumBehaviorTypeId || null,
      CompanyId: CompanyId,
      ApiFormat: ApiFormat,
      InsertedByUserId: InsertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATENEWAPI);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function modifyApi(Id, Name, Description, CompanyId, ApiKey, ApiFormat, UpdatedByUserId, SessionDurationMinutes) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Id: Id,
      Name: Name,
      Description: Description,
      CompanyId: CompanyId,
      ApiKey: ApiKey,
      ApiFormat: ApiFormat,
      UpdatedByUserId: UpdatedByUserId,
      SessionDurationMinutes: SessionDurationMinutes,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.MODIFYAPI);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function deleteApi(Id, Name, Description, ApiKey, ApiFormat, UpdatedByUserId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Id: Id,
      Name: Name,
      Description: Description,
      ApiKey: ApiKey,
      ApiFormat: ApiFormat,
      UpdatedByUserId: UpdatedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.DELETEAPI);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getApis(UserId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETAPIS);
  url += "?UserId=" + UserId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getExternalApiByUniqueId(uniqueId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETEXTERNALAPIBYUNIQUEID);
  url += "?UniqueId=" + uniqueId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getExternalApisByCompanyId(companyId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETEXTERNALAPISBYCOMPANYID);
  url += "?CompanyId=" + companyId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// External Api Type
export function getAllExternalApiTypes() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLEXTERNALAPITYPES);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// External Api Enum Options
export function getEnumOptionsByExternalApiId(externalApiId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETENUMOPTIONS);
  url += "?externalApiId=" + externalApiId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function createEnumOption(ExternalApiId, Value, Description, InsertedByUserId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      ExternalApiId: ExternalApiId,
      Value: Value,
      Description: Description,
      InsertedByUserId: InsertedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATEENUMOPTION);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function modifyEnumOption(Id, Value, Description, UpdatedByUserId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Id: Id,
      Value: Value,
      Description: Description,
      UpdatedByUserId: UpdatedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.MODIFYENUMOPTION);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function deleteEnumOption(Id, UpdatedByUserId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify({
      Id: Id,
      UpdatedByUserId: UpdatedByUserId,
    }),
  };
  let url = apiHelper.ComposeUri(apiHelper.DELETEENUMOPTION);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// Subscribers
export function getAllSubscribers() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLSUBSCRIBERS);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function createSubscriber(subscriber) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(subscriber),
  };
  let url = apiHelper.ComposeUri(apiHelper.CREATESUBSCRIBER);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function updateSubscriber(subscriber) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(subscriber),
  };
  let url = apiHelper.ComposeUri(apiHelper.UPDATESUBSCRIBER);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function getSubscriberUsageByUniqueIdForDateRange(subscriberUniqueId, startDate, endDate) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETSUBSCRIBERUSAGEBYUNIQUEIDFORDATERANGE);
  url += "?SubscriberUniqueId=" + subscriberUniqueId + "&StartDate=" + startDate + "&EndDate=" + endDate;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

export function suspendSubscriptionBySubscriberUniqueId(subscriber) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
    body: JSON.stringify(subscriber),
  };
  let url = apiHelper.ComposeUri(apiHelper.SUSPENDSUBSCRIPTIONBYSUBSCRIBERUNIQUEID);
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}

// Subscriptions
export function getSubscriptionTierByUserId(userId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETSUBSCRIPTIONTIERBYUSERID);
  url += "?UserId=" + userId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getSubscriptionByAdminUserId(adminUserId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETSUBSCRIPTIONBYADMINUSERID);
  url += "?AdminUserId=" + adminUserId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getSubscriptionBySubscriberUniqueId(subscriberUniqueId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETSUBSCRIPTIONBYSUBSCRIBERUNIQUEID);
  url += "?SubscriberUniqueId=" + subscriberUniqueId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function getSubscriptionByProjectQr(projectQr) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETSUBSCRIPTIONBYPROJECTQR);
  url += "?ProjectQr=" + projectQr;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function checkSubscriptionUserLimitByCompanyId(companyId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.CHECKSUBSCRIPTIONUSERLIMITBYCOMPANYID);
  url += "?CompanyId=" + companyId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

export function checkSubscriptionCompanyLimitByCompanyId(companyId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.CHECKSUBSCRIPTIONCOMPANYLIMITBYCOMPANYID);
  url += "?CompanyId=" + companyId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(() => {
      return null;
    });
}

// SubscriptionTiers
export function getAllSubscriptionTiers() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apiHelper.getAuthHeader(),
    },
  };

  let url = apiHelper.ComposeUri(apiHelper.GETALLSUBSCRIPTIONTIERS);

  return fetch(url, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      throw error;
    });
}
